import { render } from "./UploadBtn.vue?vue&type=template&id=1daab1a6"
import script from "./UploadBtn.vue?vue&type=script&lang=js"
export * from "./UploadBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__